const ABFieldEmailCore = require("../../core/dataFields/ABFieldEmailCore");
module.exports = class ABFieldEmail extends ABFieldEmailCore {};
